<template>
  <div class="wallpaper-detail-wrap">
    <vue-scroll
      ref="vueScroll"
      @handle-scroll="handleScroll"
    >
      <PersonalHeader :info="personalInfo" />
      <div class="bd">
        <PersonalWallpaperDetail
          :info="personalInfo"
          :dynamicdetail="dynamicDetail"
        />
        <div class="line" />
        <div class="other">
          该作者的其他壁纸：
        </div>
        <div class="list">
          <ul>
            <li
              v-for="item in list"
              :key="item.wid"
              class="item"
              :data-wid="item.wid"
              @click="handleViewDetail"
            >
              <PersonalWallpaperItem
                :data="item"
              />
            </li>
          </ul>
        </div>
      </div>
    </vue-scroll>
  </div>
</template>

<script>
// import { mapState } from 'vuex'

import { fetchDynamicDetail, fetchInfo, fetchWorks } from '@/api/personal'

import PersonalHeader from '@/components/PersonalHeader'
import PersonalWallpaperDetail from '@/components/PersonalWallpaperDetail'
import PersonalWallpaperItem from '@/components/PersonalWallpaperItem'

// 作者作品接口：1 同时查询动态和场景壁纸；2 仅查询场景，会遗漏视频作品。
const WTYPE_DYNAMIC_AND_SENCE = 1
const WTYPE_STATIC = 3
const SCROLL_RATE = 1.8

export default {
  name: 'Author',
  components: {
    PersonalHeader,
    PersonalWallpaperDetail,
    PersonalWallpaperItem,
  },
  data() {
    let dwid
    const query = this.$route.query
    if (+query.dwid) {
      dwid = +query.dwid
    }

    return {
      uid: null,
      dwid,
      personalInfo: {},
      wtype: WTYPE_DYNAMIC_AND_SENCE,
      list: [],
      page: 1,
      pageSize: 54,
      total: 0,
      isEmpty: false,
      panelHeight: 0,
      contentHeight: 0,
      loading: false,
      listEnd: false,
      dynamicDetail: {},
    }
  },
  computed: {
  },
  async mounted() {
    await this.fetchDynamicDetail()
    this.fetchInfo()
    this.fetchWorks()
  },
  methods: {
    showEmpty() {
      this.isEmpty = true
    },
    hideEmpty() {
      this.isEmpty = false
    },
    handleScroll({ scrollTop }) {
      if (!this.panelHeight) {
        this.panelHeight = this.$refs.vueScroll.scrollPanelElm.offsetHeight
      }

      if (this.loading) {
        return
      }

      if (this.listEnd) {
        return
      }

      if (!Object.keys(this.list).length) {
        return
      }

      this.contentHeight = this.$refs.vueScroll.scrollContentElm.offsetHeight

      if (scrollTop < this.contentHeight - this.panelHeight * SCROLL_RATE) {
        return
      }

      this.fetchInfiniteData()
    },
    handleSwitch(params = {}) {
      if (params.type === 'dynamic') {
        if (this.wtype === WTYPE_DYNAMIC_AND_SENCE) {
          return
        }
        this.wtype = WTYPE_DYNAMIC_AND_SENCE
      }

      if (params.type === 'static') {
        if (this.type === WTYPE_STATIC) {
          return
        }
        this.wtype = WTYPE_STATIC
      }

      this.page = 1
      this.fetchWorks()
    },
    handleViewDetail($event) {
      const wid = +$event.currentTarget.dataset.wid
      const loc = window.location
      if (wid) {
        window.open(`${loc.protocol}//${loc.host}/personal/wallpaper?dwid=${wid}`, '_self')
      }
    },
    async fetchDynamicDetail() {
      try {
        const res = await fetchDynamicDetail({
          wid: this.dwid,
        })

        if (res.resp_common && !res.resp_common.ret) {
          this.dynamicDetail = res.data
          this.uid = res.data.author_uid
        }
      } catch (err) {
        // TODO
      }
    },
    async fetchInfo() {
      if (!this.uid) {
        return
      }

      try {
        const res = await fetchInfo({
          author_uid: this.uid,
        })

        if (res.resp_common && !res.resp_common.ret) {
          this.personalInfo = res.user_info
        }
      } catch (err) {
        // TODO
      }
    },
    async fetchWorks(options = {}) {
      const { isInfinite = false } = options
      if (!isInfinite) {
        this.list = []
      }

      try {
        this.loading = true
        const res = await fetchWorks({
          author_uid: this.uid,
          wtype_support: this.wtype,
          page_size: this.pageSize,
          page: this.page,
        })

        if (res.resp_common && !res.resp_common.ret) {
          this.total = res.data.total
          const list = []
          if (res.data.list) {
            res.data.list.forEach((item) => {
              if (item.wid !== this.dwid) {
                list.push(item)
              }
            })
          }

          if (isInfinite) {
            this.list = this.list.concat(list)
          } else {
            this.list = list
          }
        }
      } catch (err) {
        // TODO
      }

      if (this.list.length) {
        this.hideEmpty()
      } else {
        this.showEmpty()
      }

      this.loading = false
    },
    async fetchInfiniteData() {
      if (this.listEnd) {
        return
      }

      if (!Object.keys(this.list).length) {
        return
      }

      this.loading = true
      this.page++

      try {
        await this.fetchWorks({
          isInfinite: true,
        })
      } catch (err) {
        // TODO
      }

      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.wallpaper-detail-wrap {
  height: 100%;
}
.bd {
  width: 1280px;
  margin: 26px auto;
  background: #fff;
  border-radius: 6px;
}
.list {
  ul {
    &::after {
      content: '';
      display: table;
      clear: both;
    }
  }
  .item {
    float: left;
    margin-left: 13px;
    margin-bottom: 10px;
    cursor: pointer;
  }
}
.line {
  height: 1px;
  margin: 0 18px 20px;
  background: #F7F8F8;
}
.other {
  margin: 19px 18px 22px;
  font-size: 14px;
  color: #333;
}
</style>
